import React, { useState } from 'react';
import styled from 'styled-components';
import { PurchasesTable, SelectCategory, CustomDatePicker } from 'components';
import { Row } from 'Design';
import { BREAKPOINTS } from 'utils';

export const Active = () => {
  const [category, setCategory] = useState('Категория');
  const [date, setDate] = useState(null);

  const handleCategory = (el) => {
    setCategory(el);
  };
  return (
    <>
      <StyledRow paddingTop={38} nowrap>
        <SelectCategory handleCategory={handleCategory} category={category} />
        <CustomDatePicker setDate={setDate} />
      </StyledRow>

      <PurchasesTable status='active' category={category} date={date} />
    </>
  );
};

const StyledRow = styled(Row)`
  gap: 32px;
  @media (max-width: ${BREAKPOINTS.sm}) {
    flex-direction: column;
    gap: 16px;
  }
`;
